module.exports = __webpack_public_path__ + "img/lt-academy.038e40bd.jpg";